/* globals PropTypes, TK */

import cn from 'classnames'

import { FormSerializer } from 'form-serializer/jquery.serialize-object'
import WizardStep from './wizard_step.js'
import PrivacyTermsCheckbox from 'portal_components/PrivacyTermsCheckbox.js.jsx'
import CheckBox from 'components/form/checkbox.js.jsx'

export default class Wizard extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      active_step: '',
      loading: false,
      rerender: false, // necessary thing for force rerendering field's values
      terms_accepted: false,
      talent_pool_agreed: false
    }
    this.formRef = React.createRef()
    this.footerRef = React.createRef()
    this.socialButtonsStubRef = React.createRef()
    this.wizardSocialButtonsRef = React.createRef()
  }

  UNSAFE_componentWillMount () {
    $.extend(FormSerializer.patterns, { fixed: /[]/ })

    this.steps = _.pick(this.props.settings, (step) => step.immutable || JSON.parse(step.visible))
    _.map(this.steps, (step, name) => { step.name = name })

    this.steps = _.omit(this.steps, (step) => step.name === 'skills' && this.props.skills_collection.length === 0)
    this.candidate = JSON.parse(this.props.candidate) || {}
    this._applySkills()
    this.authenticity_token = $('meta[name="csrf-token"]').attr('content')
    this.setState({ active_step: this.steps[_.keys(this.steps)[0]].name })
    this.socialButtons = {}
    _.map(this.props.social_buttons, (value, key) => {
      this.socialButtons[key] = _.isBoolean(value) ? value : !!parseInt(value) // "1" => true
    })
  }

  componentDidMount () {
    this.updateStubHeight()
  }

  componentDidUpdate () {
    this.updateStubHeight()
  }

  render () {
    const socialButtons = this.props.cv_buttons ? this.renderTKButtons() : this.renderSocialButtons()

    return (
      <div className='relative'>
        <form className='wizard clearfix block-body' method='post' ref={this.formRef}>
          <input type='hidden' name='utf8' value='✓' />
          <input type='hidden' name='authenticity_token' value={this.authenticity_token} />
          <input type='hidden' name='job_ad_id' value={this.props.job_ad_id || ''} />
          <input type='hidden' name='candidate[portal]' value />

          {this.renderNavigation()}
          <div className='d-flex flex-column flex-lg-row mbottom20'>
            <div className={cn({ loading: this.state.loading }, 'wizard-body col-sm-12 col-lg-7')}>
              {!this.state.rerender &&
                <WizardStep
                  {...this.activeStep()}
                  {...this.props}
                  candidate={this.candidate}
                  validate={this.validateCurrentStep.bind(this)}
                />}
            </div>
            {this.renderFooter()}
          </div>
        </form>

        {!this.props.custom_domain && socialButtons}
      </div>
    )
  }

  renderNavigation () {
    const steps = _.toArray(this.steps)

    if (steps.length > 1) {
      return (
        <ul className='wizard-header'>
          {_.sortBy(steps, (step) => step.step).map((step, i) => {
            const stepRequired = _.toArray(step.fields).filter((field) => field.required || field.immutable).length > 0
            step.step = i + 1
            return (
              <li
                key={step.name}
                className={cn({
                  active: step.name === this.state.active_step,
                  valid: step.valid,
                  invalid: step.valid === false
                })}
                onClick={null}
              >
                <div>{step.step}</div>
                <span className={cn({ 'text-muted': step.name !== this.state.active_step })}>
                  {I18n.t(`wizard_settings.steps.${step.name}`)}
                  {((!step.nested && stepRequired) || JSON.parse(step.required || 'false')) && <abbr title='required' className='mleft5'>*</abbr>}
                </span>
              </li>
            )
          })}
        </ul>
      )
    } else {
      return null
    }
  }

  renderFooter () {
    const renderPrevNext = _.toArray(this.steps).length > 1

    return (
      <div className='col-xs-12 col-lg-5 controls'>
        <div className='social-buttons-stub' ref={this.socialButtonsStubRef} />
        <div className='wizard-footer' ref={this.footerRef}>
          <div className={`${this.isLastStep() ? 'finish-visible' : 'finish-hidden'}`}>
            <div className='accept-terms'>
              {this.props.custom_confirmation &&
                <div className='mb-2'>
                  <CheckBox
                    label={<a href='/additional_agreement' target='_blank'>{this.props.custom_confirmation_label}</a>}
                    name='custom_confirmation'
                    id='custom_confirmation'
                    checked={false}
                  />
                </div>}
              {this.props.talent_pool_agreement &&
                <div className='mb-2'>
                  <CheckBox
                    label={<a href='/talent_pool_agreement' target='_blank'>{I18n.t('layouts.talent_pool_agreement_label')}</a>}
                    name='talent_pool'
                    id='talent_pool'
                    checked={false}
                  />
                </div>}
              <PrivacyTermsCheckbox
                onAccept={this.onAcceptTerms.bind(this)}
                checked={this.state.terms_accepted}
                href='/terms'
                required
              />
            </div>
            <button
              type='button'
              className='btn-primary full-width btn-lg finish mtop5'
              disabled={!this.state.terms_accepted || this.state.loading}
              onClick={this.finish.bind(this)}
            >{I18n.t('wizard_settings.layout.finish_application')}
            </button>
            {renderPrevNext && <hr />}
          </div>

          <div className='d-flex justify-content-center'>
            {renderPrevNext &&
              <button
                type='button' className='btn-default prev'
                disabled={this.activeStep().step === 1}
                onClick={this.prevStep.bind(this)}
              >
                <i className='ti-angle-left' />{I18n.t('wizard_settings.layout.prev_step')}
              </button>}

            {renderPrevNext &&
              <button
                type='button' className='btn-primary next'
                disabled={this.activeStep().step === _.toArray(this.steps).length}
                onClick={this.nextStep.bind(this)}
              >
                <i className='ti-angle-right' />{I18n.t('wizard_settings.layout.next_step')}
              </button>}
          </div>
        </div>
      </div>
    )
  }

  renderSocialButtons () {
    const {
      linkedin_url: linkedinUrl,
      xing_url: xingUrl,
      facebook_url: facebookUrl
    } = this.props

    return (
      <div ref={this.wizardSocialButtonsRef} className={`wizard-social-buttons col-xs-12 col-lg-5 wizard-steps-count-${_.toArray(this.steps).length}`}>
        <div className='row justify-content-center'>
          {this.socialButtons.allow_linkedin &&
            <div className='col-5' dangerouslySetInnerHTML={{ __html: linkedinUrl }} />}

          {this.socialButtons.allow_xing &&
            <div className='col-5' dangerouslySetInnerHTML={{ __html: xingUrl }} />}

          {this.socialButtons.allow_facebook &&
            <div className='col-5' dangerouslySetInnerHTML={{ __html: facebookUrl }} />}
        </div>
        <p className='wizard-social-buttons-hint text-muted small italic mtop15 mbottom30'>{I18n.t('wizard_settings.layout.hint')}</p>
      </div>
    )
  }

  renderTKButtons () {
    const {
      linkedin_url: linkedinUrl,
      xing_url: xingUrl,
      facebook_url: facebookUrl
    } = this.props

    return (
      <div ref={this.wizardSocialButtonsRef} className={`wizard-social-buttons col-xs-12 col-lg-5 wizard-steps-count-${_.toArray(this.steps).length}`}>
        <div id='TK_WIDGET_CONTAINER' className='container'>
          <div id='TK_WIDGET_INITIATOR' />
          <div className='row justify-content-center'>
            {this.socialButtons.allow_linkedin &&
              <div className='col-5' dangerouslySetInnerHTML={{ __html: linkedinUrl }} />}

            {this.socialButtons.allow_xing &&
              <div className='col-5' dangerouslySetInnerHTML={{ __html: xingUrl }} />}

            {this.socialButtons.allow_facebook &&
              <div className='col-5' dangerouslySetInnerHTML={{ __html: facebookUrl }} />}

            {this.socialButtons.allow_dropbox &&
              <div className='col-5'>
                <div className='TK-widget-link dropbox w-100 btn-default' onClick={() => TK.Dropbox.openPicker()}>
                  <i className='fab fa-dropbox' />
                  Dropbox
                </div>
              </div>}
          </div>

          {this.socialButtons.allow_googledrive &&
            <div className='TK-widget-link googledrive btn-default' onClick={() => TK.GoogleDrive.openPicker()}>
              <i><img src='https://home.textkernel.de/match//styles/images/widget/grid/googledrive.svg' /></i>
              GoogleDrive
            </div>}

          {this.socialButtons.allow_onedrive &&
            <div className='TK-widget-link onedrive btn-default' onClick={() => TK.OneDrive.openPicker()}>
              <i><img src='https://home.textkernel.de/match//styles/images/widget/grid/onedrive.svg' /></i>
              OneDrive
            </div>}

          {this.socialButtons.allow_cv &&
            <div>
              <hr />
              <div className='TK-widget-link tk-widget btn-default'>
                <div className='TK_WIDGET' rel='cv' />
                {I18n.t('wizard_settings.layout.tk_widget_cv')}
              </div>
            </div>}
          {this.showButtonsHint() &&
            <p className='wizard-social-buttons-hint text-muted small italic mtop15 mbottom30'>{I18n.t('wizard_settings.layout.hint')}</p>}
        </div>
      </div>
    )
  }

  TKRedirect (key) {
    TK.redirectToLinkRequest(key, key)
  }

  onAcceptTerms (event) {
    this.setState({ terms_accepted: event.target.checked })
  }

  activeStep () {
    return this.steps[this.state.active_step]
  }

  prevStep () {
    this.setActiveStep(_.findKey(this.steps, (step) => step.step === this.activeStep().step - 1))
  }

  nextStep () {
    this.validateCurrentStep(
      () => this.setState({ loading: true }),
      (currentStep) => this.setState({ loading: false }),
      (currentStep) => this.setActiveStep(_.findKey(this.steps, (step) => step.step === currentStep.step + 1))
    )
  }

  finish () {
    const urlMarkerForFinishStep = '?step=finish'

    this.validateCurrentStep(
      () => this.setState({ loading: true }),
      () => { this.setState({ loading: false }) },
      () => { window.location.href = this.props.finish_path + urlMarkerForFinishStep }
    )
  }

  isLastStep () {
    return this.activeStep().step === _.toArray(this.steps).length
  }

  validateCurrentStep (beforeHandle, errorHandle, successHandle) {
    const $form = $(this.formRef.current)

    setTimeout(() => {
      const data = this._getDataObject($form)

      if ($form.find('.address').hasClass('has-error')) return // address input validation
      if (typeof beforeHandle === 'function') beforeHandle.call(this)

      $.post(this.props.path, data, (response) => {
        const currentStep = this.steps[response.active_step]
        _.map(currentStep.fields, (field) => currentStep.nested ? delete field.nested_errors : delete field.error)
        if (response.errors) {
          currentStep.valid = false
          this._assignErrors(response.errors, currentStep)
          if (typeof errorHandle === 'function') errorHandle.call(this, currentStep, response.errors)
        } else {
          if (response.candidate) {
            currentStep.valid = true
            this.candidate = response.candidate
            this._applySkills()
            this.forceUpdate()
          }
          if (typeof successHandle === 'function') successHandle.call(this, currentStep)
        }
      })
    }, 301)
  }

  setActiveStep (step) {
    const url = new URL(window.location)
    url.searchParams.set('step', step)
    window.history.pushState({}, '', url)

    this.setState({ rerender: true }) // unnecessary thing for force rerendering field's values
    if (typeof step === 'string') {
      this.setState({ active_step: step, loading: false, rerender: false })
    } else {
      this.setState({ active_step: step.name, loading: false, rerender: false })
    }
  }

  updateStubHeight () {
    $(document).trigger('resize')
    $(this.socialButtonsStubRef.current).height($(this.wizardSocialButtonsRef.current).height() + 60 + $(this.footerRef.current).height())
  }

  showButtonsHint () {
    return !(_.isEmpty(_.pick(this.socialButtons, sb => sb)))
  }

  _getDataObject (form) {
    const data = form.serializeObject()
    _.map(data.candidate, (object, name) => {
      if (_.isArray(object)) {
        data.candidate[name] = _.without(object, undefined)
      }
    })
    return data
  }

  _assignErrors (errors, step) {
    if (step.required) {
      step.errors = errors
    } else if (step.nested) { // work_experiences, education_items, project_works
      errors.map((error) => {
        return _.map(error, (errorFields, id) => {
          errorFields.title = errorFields[`title_${I18n.defaultLocale}`] // title error comes as title_en
          _.map(step.fields, (field, fieldName) => {
            if (!step.fields[fieldName].nested_errors) step.fields[fieldName].nested_errors = {}
            if (errorFields[fieldName]) step.fields[fieldName].nested_errors[id] = errorFields[fieldName][0]
          })
        })
      })
    } else { // other steps
      _.map(errors, (error, fieldName) => {
        step.fields[fieldName].error = _.isArray(error) ? error[0] : error
      })
    }
  }

  _applySkills () {
    this.candidate.skills.map((newSkill) => {
      return this.props.skills_collection.map((skill) => {
        return assignLevel(skill, newSkill)
      })
    })

    function assignLevel (skill, newSkill) {
      if (skill.skill_id === newSkill.skill_id) {
        skill.candidate_stars = newSkill.level
        skill.id = newSkill.id
      }
      skill.children.map((child) => assignLevel(child, newSkill))
    }
  }
}

Wizard.propTypes = {
  path: PropTypes.string.isRequired,
  settings: PropTypes.object.isRequired,
  candidate: PropTypes.string.isRequired
}
